import React from "react";
import Select, {
  ActionMeta,
  GroupBase,
  Options,
  SingleValue,
  StylesConfig,
} from "react-select";
import { SelectComponents } from "react-select/dist/declarations/src/components";
import { useTheme } from "@glossy/theme";
import {
  Size,
  Variant,
  getCustomStyles,
  getCustomizedTheme,
  selectComponents,
} from "../styles";

interface IProps<T extends Record<string, any>> {
  size?: Size;
  variant?: Variant;
  customStyles?: StylesConfig<T, false, GroupBase<any>>;
  className?: string;
  isSearchable?: boolean;
  isMulti?: boolean;
  isClearable?: boolean;
  placeholder?: string;
  menuPortalTarget?: HTMLElement;
  isDisabled?: boolean;
  onChange?: (newValue: SingleValue<T>, actionMeta: ActionMeta<any>) => void;
  components?: Partial<SelectComponents<any, false, GroupBase<any>>>;
  value?: T;
  defaultValue?: T;
  hideSelectedOptions?: boolean;
  defaultMenuIsOpen?: boolean;
  options?: T[];
  name?: string;
  formatOptionLabel?: (option: T) => React.ReactNode;
  isOptionDisabled?: (option: T, selectValue: Options<T>) => boolean;
}

const UiKitFormSelectSimple = <T extends Record<string, any>>({
  components,
  size = "m",
  variant = "secondary",
  customStyles,
  onChange,
  value,
  options,
  defaultValue,
  hideSelectedOptions,
  defaultMenuIsOpen,
  name,
  className,
  isMulti,
  ...props
}: IProps<T>) => {
  const theme = useTheme();
  const styles = {
    ...getCustomStyles(theme, size, variant),
    ...customStyles,
  };

  return (
    <Select
      theme={getCustomizedTheme(theme, size)}
      styles={styles}
      components={{ ...selectComponents, ...components }}
      backspaceRemovesValue={props.isSearchable || isMulti || props.isClearable}
      blurInputOnSelect
      onChange={onChange}
      value={value}
      options={options}
      menuPlacement="auto"
      defaultValue={defaultValue}
      hideSelectedOptions={hideSelectedOptions}
      defaultMenuIsOpen={defaultMenuIsOpen}
      name={name}
      // @ts-ignore isMulti is typed 'false | undefined', which is an error from React Select.
      isMulti={isMulti}
      {...props}
    />
  );
};

export default UiKitFormSelectSimple;
